import React from 'react';

import { Grid } from '@mui/material';

import { Loading } from './RfpLoader';

const SuspenseFallback = ({ fullscreen = false }: { fullscreen?: boolean }) => (
  <Grid
    container
    justifyContent='center'
    alignItems='center'
    sx={
      fullscreen
        ? {
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 1200
          }
        : {
            width: '100%',
            height: '100%'
          }
    }>
    <Loading width={32} height={32} />
  </Grid>
);

export default SuspenseFallback;
